import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const PolicyEndorsementIssued = (props) => {
  return (
    <FormGroup controlId="policyEndorsementIssued">
      <Col componentClass={ControlLabel} sm={2}>
        Policy / Endorsement Issued
      </Col>
      <Col sm={10}>
            <select
              className="custom-select"
              onChange={props.handleChangePolicyEndorsementIssued}
              value={props.policyEndorsementIssued}
            >
              <option value="">Please Select</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
      </Col>
    </FormGroup>
  )
}

PolicyEndorsementIssued.propTypes = {
  handleChangePolicyEndorsementIssued: PropTypes.func,
  policyEndorsementIssued: PropTypes.string
};

export default PolicyEndorsementIssued;



// WEBPACK FOOTER //
// ./src/app/components/policyEndorsementIssued/PolicyEndorsementIssued.js